export const actions = {
  LADRONES_LOAD_REQUESTED: 'LADRONES_LOAD_REQUESTED',
  LADRONES_LOAD_SUCCEEDED: 'LADRONES_LOAD_SUCCEEDED',
  LADRONES_LOAD_FILED: 'LADRONES_LOAD_FILED',

  LADRON_UPDATE_REQUESTED: 'LADRON_UPDATE_REQUESTED',
  LADRON_UPDATE_SUCCEEDED: 'LADRON_UPDATE_SUCCEEDED',
  LADRON_UPDATE_FILED: 'LADRON_UPDATE_FILED',

  LADRON_INSERT_REQUESTED: 'LADRON_INSERT_REQUESTED',
  LADRON_INSERT_SUCCEEDED: 'LADRON_INSERT_SUCCEEDED',
  LADRON_INSERT_FILED: 'LADRON_INSERT_FILED',

  LADRON_DELETE_REQUESTED: 'LADRON_DELETE_REQUESTED',
  LADRON_DELETE_SUCCEEDED: 'LADRON_DELETE_SUCCEEDED',
  LADRON_DELETE_FILED: 'LADRON_DELETE_FILED',
}

export const getLadronesAction = dispatch => {
  dispatch({
    type: actions.LADRONES_LOAD_REQUESTED,
  })
}

export const onSubmitInsertLadronFormAction = (dispatch, formLadron) => {
  dispatch({
    type: actions.LADRON_INSERT_REQUESTED,
    payload: formLadron,
  })
}

export const onSubmitUpdateLadronFormAction = (dispatch, formLadron) => {
  dispatch({
    type: actions.LADRON_UPDATE_REQUESTED,
    payload: formLadron,
  })
}

export const deleteLadronAction = (dispatch, id) => {
  dispatch({
    type: actions.LADRON_DELETE_REQUESTED,
    payload: id,
  })
}
